import { z } from 'zod';
import { PROMOTION_CONSTRAINTS } from './constraints.js';
/** A 0–100 percentage with cents-level precision, matching the DB's chk_promotion_*_pct and Decimal(5,2). */
export const promotionPercentSchema = (label) => z
    .number({ error: `${label} must be a number.` })
    .min(PROMOTION_CONSTRAINTS.pct.min, `${label} cannot be negative.`)
    .max(PROMOTION_CONSTRAINTS.pct.max, `${label} must be ${PROMOTION_CONSTRAINTS.pct.max} or less.`)
    .refine((value) => Number(value.toFixed(2)) === value, `${label} cannot have more than 2 decimal places.`);
//# sourceMappingURL=percent-schema.js.map